import { render, staticRenderFns } from "./VirusDialog.vue?vue&type=template&id=2a6e28c4&scoped=true"
import script from "./VirusDialog.vue?vue&type=script&lang=js"
export * from "./VirusDialog.vue?vue&type=script&lang=js"
import style0 from "./VirusDialog.vue?vue&type=style&index=0&id=2a6e28c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6e28c4",
  null
  
)

export default component.exports